<template>
  <SSection
    v-if="item.recommended && item.recommended[1].length"
    :has-separator="false"
  >
    <template #no-container>
      <CottageSwiperRecommended :cottages="item.recommended[1]" />
    </template>
  </SSection>
</template>

<script setup lang="ts">
import type { CottagePage } from '../../entities/CottagePage'

type itemType = Pick<CottagePage, 'recommended'>

interface propsInterface {
  item: itemType
}

defineProps<propsInterface>()
</script>
